/**
 * The Atlas shell: fixed sidebar, sticky header, routed page content.
 *
 * Renders once the session query has resolved, because the sidebar's contents
 * are a server-provided fact and there is nothing sensible to draw before the
 * server has answered.
 */

import { Outlet } from 'react-router-dom';

import { useSessionScope } from '@/session/SessionScopeContext';

import { BootScreen } from './BootScreen';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useNavCollapse } from './useNavCollapse';

export function AppShell() {
  const { collapsed, toggle } = useNavCollapse();
  const { isLoading, error } = useSessionScope();

  if (isLoading) return <BootScreen />;
  if (error) return <BootScreen error />;

  return (
    <div className="app">
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div className="app-main">
        <Header />
        <main className="page">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
